(() => {
document.addEventListener('DOMContentLoaded', function () {
  if (!window.lowStockVariants) return;

  function getVariantId() {
    const input =
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"]');
    return input ? String(input.value) : null;
  }

  function render() {
    const id = getVariantId();
    if (!id) return;

    const v = window.lowStockVariants.find(x => String(x.id) === id);

    document.querySelectorAll('.low-stock-warning').forEach(function (el) {
      if (v) {
        el.textContent = `Only a few items left`;
        el.style.display = '';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  }

  render();

  document.addEventListener('change', function (e) {
    if (e.target.closest('form')) {
      setTimeout(render, 0);
    }
  });

  document.addEventListener('shopify:section:load', render);
});

})();